import { getGlobals } from "storyblok/api"
import { getCommunityPostsPaths, getCommunityPost } from "storyblok/inYourCommunity"
import richText from "utilities/richText"
import PageHeader from "components/DynamicComponent/molecules/PageHeader"
import ArticleSection from "components/Archive/ArticleSection"
import Meta from "components/Meta"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"
import DynamicComponent from "components/DynamicComponent"

export default function CommunityPost({ story }) {
  if (story?.content?.component === "page") {
    return (
      <>
        <Meta info={story?.content?.twentysixty_seo} />
        <DynamicComponent blok={story?.content} />
      </>
    )
  }

  return (
    <>
      <Meta
        info={{
          title: `${story?.content?.name}`,
          og_title: `${story?.content?.name}`,
          twitter_title: `${story?.content?.name}`,
        }}
      />
      <StoryblokVisualEditor story={story?.content}>
        <main className="main-content" data-pagefind-body data-pagefind-sort="weight[data-weight]" data-weight="5">
          <PageHeader
            blok={{
              type: "standard",
              heading: story?.content?.name,
              breadcrumbs: [{ text: "In Your Community", href: "/in-your-community" }, { text: story?.content?.name }],
            }}
          />
          <ArticleSection>{richText(story?.content?.content)}</ArticleSection>
        </main>
      </StoryblokVisualEditor>
    </>
  )
}

export async function getStaticProps({ params: { post }, preview = null }) {
  const globals = await getGlobals("exclude-global-sections")
  const story = await getCommunityPost(`in-your-community/${post}`, preview)

  return {
    props: {
      story: story ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getCommunityPostsPaths(),
    fallback: false,
  }
}
